import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import { AiFillExclamationCircle } from 'react-icons/ai';
import './s-input.component.scss';

interface SInputInterface {
  name: any;
  type: string;
  placeholder: string;
  className?: string;
  error: any;
  control?: any;
  style?: any;
  disabled?: boolean;
  readonly?: boolean;
  onChange?: any;
  onBlur?: any;
  rules?: any;
  defaultValue?: any;
  min?: number;
}

/**
 * @param props.name
 * @param props.placeholder
 * @param props.register
 * @param props.errors
 * @param props.className
 * @param props.disable
 * @returns
 */
const SInputComponent = ({ defaultValue, name, type, placeholder, error, className, style, disabled, readonly, control, rules, min, onChange, onBlur }: SInputInterface) => {
  return (
    <div className={`s-input-wrapper ${className} ${error ? 'error border-2 border-danger' : ''}`}>
      <Controller
        defaultValue={defaultValue ? defaultValue : ''}
        name={name}
        control={control}
        rules={rules}
        render={({ field }) =>
          <input
            {...field}
            type={type}
            className="form-control s-input"
            placeholder={placeholder}
            style={style}
            disabled={disabled}
            autoComplete="off"
            readOnly={readonly}
            onBlur={() => onBlur && onBlur()}
            onChange={(e: any) => {
              if (type === 'number' && min !== undefined && e.target.value < min) {
                e.target.value = min
              }
              field.onChange(e);
              onChange && onChange(e.target.value);
            }}
          />}
      />
      <OverlayTrigger
        // show={!!error}
        trigger={["hover", "hover"]}
        placement="top"
        overlay={<Tooltip id={`tooltip-${name}`}>{error?.message}</Tooltip>}
      >
        <AiFillExclamationCircle className="text-danger position-absolute error-icon" size={22} />
      </OverlayTrigger>
    </div>
  );
};

export default SInputComponent;
